import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { MainScene } from "./scenes/MainScene";
import { EventScene } from "src/games/demos/phaserGamePadDemo/scenes/EventScene";

interface PhaserModalButtonDemoProps {
}

interface PhaserModalButtonDemoState {
}

const config: GameConfig = {
    title: "Modal Button Demo",
    version: "0.0.1-superAlpha",
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 0 }
        }
    },
    backgroundColor: "#000000"
};

class PhaserModalButtonDemo extends React.Component<PhaserModalButtonDemoProps, PhaserModalButtonDemoState> {
    private game: Phaser.Game;
    constructor(props:PhaserModalButtonDemoProps) {
        super(props);
        bindAllOfThis(this, PhaserModalButtonDemo.prototype);
    }

    render() {
        var scenes = [ MainScene, EventScene ];
        return (<div>
            <PhaserGameComponent scenes={scenes} config={config} />
        </div>);
    }
}

export default PhaserModalButtonDemo;



// WEBPACK FOOTER //
// ./src/games/demos/modalButtonComponentDemo/Main.tsx